import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
  selector: 'app-update-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  template: `
    <div class="p-6">
      <div class="flex flex-col items-center text-center">
        <mat-icon class="mb-4 text-5xl text-primary-500">system_update_alt</mat-icon>
        <h2 class="mb-2 text-xl font-semibold">Actualización completada</h2>
        <p class="mb-6 text-gray-600 dark:text-gray-400">
          Hemos incorporado actualizaciones a la aplicación. Por favor, vuelve a iniciar sesión para continuar. Disculpa
          las molestias.
        </p>
        <button mat-flat-button color="primary" (click)="closeDialog()">Entendido</button>
      </div>
    </div>
  `,
})
export class UpdateDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<UpdateDialogComponent>,
    private router: Router
  ) {}

  closeDialog(): void {
    this.dialogRef.close();
    this.router.navigate(['/sign-in']);
  }
}
